import React from 'react';
import GooglePayButton from '@google-pay/button-react';
import { DH } from '../../../utils/dataHooks';
import { Locale } from '../../../types/Locale';
import { GooglePayButtonConfig } from './types';
import s from './styles.scss';

interface GooglePayViewProps {
  locale: Locale;
  color: 'white' | 'black';
  height?: number;
  paymentRequest: GooglePayButtonConfig['paymentRequest'];
  onReadyToPayChange?: GooglePayButtonConfig['onReadyToPayChange'];
  onClick?: GooglePayButtonConfig['onClick'];
  onLoadPaymentData?: GooglePayButtonConfig['onLoadPaymentData'];
  onCancel?: GooglePayButtonConfig['onCancel'];
  onError?: GooglePayButtonConfig['onError'];
  onPaymentAuthorized?: GooglePayButtonConfig['onPaymentAuthorized'];
  onPaymentDataChanged?: GooglePayButtonConfig['onPaymentDataChanged'];
}

export const GooglePayView: React.FC<GooglePayViewProps> = (props) => {
  const style = typeof props.height === 'number' ? { height: `${props.height}px` } : {};

  return (
    <section data-hook={DH.GooglePay.Button}>
      <GooglePayButton
        environment={process.env.NODE_ENV === 'development' ? 'TEST' : 'PRODUCTION'}
        className={s.googlePayButton}
        buttonType="plain"
        buttonSizeMode="fill"
        buttonColor={props.color}
        buttonLocale={props.locale}
        style={style}
        // When set to true (and environment is Production), the Google Pay button will only be displayed if the user already has an existing payment that they can use to make a purchase.
        existingPaymentMethodRequired={false}
        paymentRequest={props.paymentRequest}
        onReadyToPayChange={props.onReadyToPayChange}
        onClick={props.onClick}
        onLoadPaymentData={props.onLoadPaymentData}
        onCancel={props.onCancel}
        onError={props.onError}
        onPaymentAuthorized={props.onPaymentAuthorized}
        onPaymentDataChanged={props.onPaymentDataChanged}
      />
    </section>
  );
};
